/* eslint-disable no-restricted-globals */
import React, { useEffect } from 'react';
import { BasicTreeData, GridExample } from './ManageAgenciesTable';
import './BoxShadow.css';
function ExpandAbleTable(props) {
  return (
    <div
      className='card'
      style={{
        margin: '5px 10px 0px 10px',
        backgroundColor: '#EEF3F9'
      }}
    >
      <BasicTreeData PreviouProps={props} />
    </div>
  );
}

export default ExpandAbleTable;
